import { MasterListPage } from "@/pages/admin/MasterListPage";
import { Layers3 } from "lucide-react";

export default function AdminCostCenter() {
  return (
    <MasterListPage
      title="Cost Center"
      kicker="Master Data"
      description="Daftar baku kategori pembebanan biaya. Dipakai sebagai pilihan dropdown di profil pegawai."
      icon={Layers3}
      endpoint="/master/cost-center"
      testPrefix="cost-center"
      addLabel="Tambah Cost Center"
      emptyLabel="Belum ada Cost Center. Klik tombol di atas untuk menambahkan."
      namaPlaceholder="Contoh: Head Office - Corporate"
      kodePlaceholder="Contoh: HO-COR"
    />
  );
}
